const AUTH_ENTRY = new Set(['/login', '/join']);

/** Экран входа не является разделом приложения. После сессии с него уходим. */
export function isAuthEntryPath(pathname: string): boolean {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return AUTH_ENTRY.has(path);
}

/**
 * Куда вести после входа, если адрес — экран входа.
 * `?next=` принимается только как внутренний путь; иначе «Сегодня» (`/`).
 */
export function pathAfterLogin(search: string): string {
  const next = safeNextPath(new URLSearchParams(search).get('next'));
  return next ?? '/';
}

/** Внутренний путь приложения. Внешний адрес, схема и сам экран входа отбрасываются. */
export function safeNextPath(value: string | null | undefined): string | null {
  if (!value) return null;
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return null;
  if (value.includes('\\') || value.includes('://') || /[\u0000-\u001f\u007f]/.test(value)) return null;

  let url: URL;
  try {
    url = new URL(value, 'http://jack-os.local');
  } catch {
    return null;
  }
  if (url.origin !== 'http://jack-os.local' || url.username || url.password) return null;

  const path = normalizeAppPath(url.pathname);
  if (!path || AUTH_ENTRY.has(path)) return null;
  return path + url.search + url.hash;
}

/** Схлопывает `.` и `..` и не пускает путь, который после раскодирования смотрит наружу. */
function normalizeAppPath(pathname: string): string | null {
  let decoded: string;
  try {
    decoded = decodeURIComponent(pathname);
  } catch {
    return null;
  }
  if (!decoded.startsWith('/') || decoded.startsWith('//') || decoded.includes('\\') || decoded.includes('://')) return null;
  const segments: string[] = [];
  for (const part of decoded.split('/')) {
    if (part === '' || part === '.') continue;
    if (part === '..') {
      if (segments.length === 0) return null;
      segments.pop();
      continue;
    }
    segments.push(part);
  }
  const path = `/${segments.join('/')}`.replace(/\/+$/, '') || '/';
  return path.startsWith('/') && !path.startsWith('//') ? path : null;
}
